import { AuthGuard } from './all-modules/core/guard/auth.guard';
import { MainLayoutComponent } from './layout/app-layout/main-layout/main-layout.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserProfileComponent } from './layout/user-profile/user-profile.component';
import { DashboardComponent } from './all-modules/shared/components/dashboard/dashboard.component';
import { MODULE_CONSTANTS, MODULE_GROUP_CONSTANTS, ROLE_CONSTANTS } from './all-modules/shared/constants/constant';
import { SoClientFeedbackComponent } from './expose-compoment/so-client-feedback/so-client-feedback.component';
import { DashboardCMComponent } from './all-modules/shared/components/dashboard-cm/dashboard-cm.component';
import { DashboardAccountingComponent } from './all-modules/shared/components/dashboard-accounting/dashboard-accounting.component';
import { DashboardAccountCoordinatorComponent } from './all-modules/shared/components/dashboard-account-coordinator/dashboard-account-coordinator.component';
import { CalendarViewAsAmComponent } from './all-modules/shared/components/calendar-view-as-am/calendar-view-as-am.component';
import { LaborAvailabilityConfirmationComponent } from './expose-compoment/labor-availability-confirmation/labor-availability-confirmation.component';
import {
  ServiceOrderViewPdfComponent
} from "./all-modules/service-order/components/service-order-view-pdf/service-order-view-pdf.component";
import { EmailViewerComponent } from './all-modules/email-viewer/email-viewer/email-viewer.component';
import { SecurePhotoGalleryComponent } from './expose-compoment/secure-photo-gallery/secure-photo-gallery.component';
import { ShortLinkRedirectComponent } from './expose-compoment/short-link-redirect/short-link-redirect.component';
import { ReportLinkComponent } from './expose-compoment/report-link/report-link.component';

const routes: Routes = [
  { path: '', redirectTo: '/auth/signin', pathMatch: 'full' },
  {
    path: 'so-client-feedback/:id',
    component: SoClientFeedbackComponent
  },
  {
    path: 'lc/:id',
    component: LaborAvailabilityConfirmationComponent
  },
  {
    path: 'soviewpdf/:id/:price',
    component: ServiceOrderViewPdfComponent,
  },
  // Public (anonymous) client photo gallery — MUST stay outside the AuthGuard-protected
  // MainLayoutComponent block, otherwise the client is bounced to the sign-in page.
  {
    path: 'gallery/:token',
    component: SecurePhotoGalleryComponent
  },
  // Public SMS short links (replaces Bitly). Also outside the AuthGuard block — a client has no login.
  {
    path: 's/:key',
    component: ShortLinkRedirectComponent
  },
  // DPP-143: public report link from system emails. Outside the AuthGuard block — a client has no login.
  // Not 'report/:token': that would capture the signed-in Reports pages (/report/audit-report ...).
  {
    path: 'report-link/:token',
    component: ReportLinkComponent
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      moduleKey:[MODULE_CONSTANTS.COMMON],
      groupKey:[MODULE_GROUP_CONSTANTS.COMMON],
    },
    children: [{
      path: 'admin',
      loadChildren: () =>
        import('./all-modules/admin/admin.module').then((m) => m.AdminModule),
      data: {
        moduleKey:[MODULE_GROUP_CONSTANTS.ADMIN],
        groupKey:[MODULE_GROUP_CONSTANTS.ADMIN],
      }
    },
    {
      path: 'weekly-meet',
      loadChildren: () =>
        import('./all-modules/weekly-meeting/weekly-meet.module').then((m) => m.WeeklyMeetModule),
      data: {
        moduleKey:[MODULE_CONSTANTS.COMMON],
        groupKey:[MODULE_GROUP_CONSTANTS.COMMON],
        }
    },
    {
      path: 'so',
      loadChildren: () =>
        import('./all-modules/service-order/service-order.module').then((m) => m.ServiceOrderModule),
      data: {
        moduleKey:[MODULE_CONSTANTS.SERVICE_ORDER],
        groupKey:[MODULE_GROUP_CONSTANTS.SERVICE_ORDER],
        }
    },
    {
      path: 'user-profile',
      title:'User Profile',
      canActivate: [AuthGuard],
      component: UserProfileComponent,
      data: {
        moduleKey:[MODULE_CONSTANTS.COMMON],
        groupKey:[MODULE_GROUP_CONSTANTS.COMMON],
      }
    },
   
    {
      path: 'dashboard',
      title:'Dashboard',
      canActivate: [AuthGuard],
      component: DashboardComponent,
      data: {
        moduleKey:[MODULE_CONSTANTS.DASHBOARD],
        groupKey:[MODULE_GROUP_CONSTANTS.DASHBOARD],
     }
    },
    {
      path: 'leadership-operations',
      loadChildren: () =>
        import('./all-modules/leadership-operations/leadership-operation.module').then((m) => m.LeadershipOperationModule),
      data: {
        moduleKey:[MODULE_GROUP_CONSTANTS.LEADERSHIP_OPERATION],
        groupKey:[MODULE_GROUP_CONSTANTS.LEADERSHIP_OPERATION],
        }
    },
    {
      path: 'dashboard-cm',
      title:'Dashboard City Manager',
      canActivate: [AuthGuard],
      component: DashboardCMComponent,
      data: {
        moduleKey:[MODULE_CONSTANTS.DASHBOARD],
        groupKey:[MODULE_GROUP_CONSTANTS.DASHBOARD],
      }
    },
    {
      path: 'dashboard-accounting',
      title:'Dashboard Accounting',
      canActivate: [AuthGuard],
      component: DashboardAccountingComponent,
      data: {
        moduleKey:[MODULE_CONSTANTS.DASHBOARD, MODULE_CONSTANTS.ACCOUNTING_DASHBOARD],
        groupKey:[MODULE_GROUP_CONSTANTS.DASHBOARD, MODULE_GROUP_CONSTANTS.ACCOUNTING],
      }
    },
    {
      path: 'dashboard-account-coordinator',
      title:'Dashboard Account Coordinator',
      canActivate: [AuthGuard],
      component: DashboardAccountCoordinatorComponent,
      data: {
        moduleKey:[MODULE_CONSTANTS.DASHBOARD],
        groupKey:[MODULE_GROUP_CONSTANTS.DASHBOARD],
      }
    },
    {
      path: 'job-planning',
      loadChildren: () =>
        import('./all-modules/job-labor-planning/job-labor-planning.module').then((m) => m.JobLaborPlanningModule),
      data: {
        moduleKey:[MODULE_CONSTANTS.JOB_LABOR_PLANNING, MODULE_CONSTANTS.DAILY_ACTIVITY],
        groupKey:[MODULE_GROUP_CONSTANTS.CITY_MANAGER],
        }
    },
    {
      path: 'accounting',
      loadChildren: () =>
        import('./all-modules/accounting/accounting.module').then((m) => m.AccountingModule),
      data: {
        moduleKey:[MODULE_GROUP_CONSTANTS.ACCOUNTING],
        groupKey:[MODULE_GROUP_CONSTANTS.ACCOUNTING],
        }
    },
    {
      path: 'account-manager',
      loadChildren: () =>
        import('./all-modules/account-manager/account-manager.module').then((m) => m.AccountManagerModule),
      data: {
        moduleKey:[MODULE_GROUP_CONSTANTS.ACCOUNT_MANAGER],
        groupKey:[MODULE_GROUP_CONSTANTS.ACCOUNT_MANAGER],
        }
    },
    {
      path: 'account-supervisor',
      loadChildren: () =>
        import('./all-modules/account-supervisor/account-supervisor.module').then((m) => m.AccountSupervisorModule),
      data: {
        moduleKey:[MODULE_GROUP_CONSTANTS.ACCOUNT_SUPERVISOR],
        groupKey:[MODULE_GROUP_CONSTANTS.ACCOUNT_SUPERVISOR],
        }
    },
    {
      path: 'calendar-view-as-am',
      title:'Calendar View',
      canActivate: [AuthGuard],
      component: CalendarViewAsAmComponent,
      data: {
        moduleKey:[MODULE_CONSTANTS.DASHBOARD],
        groupKey:[MODULE_GROUP_CONSTANTS.DASHBOARD],
      }
    },
    {
      path: 'account-executive',
      loadChildren: () =>
        import('./all-modules/account-executive/account-executive.module').then((m) => m.AccountExecutiveModule),
      data: {
        moduleKey:[MODULE_GROUP_CONSTANTS.DASHBOARD],
        groupKey:[MODULE_GROUP_CONSTANTS.DASHBOARD],
        }
    },
    {
      path: 'leadership-sales',
      loadChildren: () =>
        import('./all-modules/leadership-sales/leadership-sales.module').then((m) => m.LeadershipSalesModule),
      data: {
        moduleKey:[MODULE_GROUP_CONSTANTS.DASHBOARD],
        groupKey:[MODULE_GROUP_CONSTANTS.DASHBOARD],
        }
    },
    {
      path: 'report',
      loadChildren: () =>
        import('./all-modules/report/report.module').then((m) => m.ReportModule),
      data: {
        moduleKey:[MODULE_GROUP_CONSTANTS.REPORT],
        groupKey:[MODULE_GROUP_CONSTANTS.REPORT],
        }
    },
    {
      path: 'show-job-central',
      loadChildren: () =>
        import('./all-modules/show-job-central/show-job-central.module').then((m) => m.ShowJobCentralModule),
      data: {
        moduleKey:[MODULE_GROUP_CONSTANTS.SHOW_JOB_CENTRAL],
        groupKey:[MODULE_GROUP_CONSTANTS.SHOW_JOB_CENTRAL],
        }
    },
    {
      path: 'email-viewer',
      loadChildren: () =>
          import('./all-modules/email-viewer/email-viewer.module').then((m) => m.EmailViewerModule),
      data: {
        moduleKey:[MODULE_GROUP_CONSTANTS.EMAIL_VIEWER],
        groupKey:[MODULE_GROUP_CONSTANTS.EMAIL_VIEWER],
      }
    },
  ],
  },
  { path: 'auth', loadChildren: () => import('./all-modules/auth/auth.module').then((m) => m.AuthModule) }
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
